import { IsString, IsNotEmpty } from 'class-validator';

import type { FileInputValue } from '@vk-hr-tek/ui/input';

export class BannerSimple {
  @IsString()
  @IsNotEmpty()
  background?: FileInputValue & { id?: string };

  @IsString()
  @IsNotEmpty()
  url: string;
}
